import { getLocateText, oddsKeyArray, locateKeys } from '../oddsKeyArray'

const initDesignated = () => {
  const mainKey = 'designated'
  const keyObj = {}

  locateKeys.forEach((supKey, index) => {
    for (let j = 1; j <= 11; j++) {
      const groupKey = getLocateText(j, index + 1)
      keyObj[groupKey] = {
        mainKey,
        supKey,
        groupKey
      }
    }
  })

  return keyObj
}

const initTwoSide = () => {
  const mainKey = 'two_side'
  const totalSumKey = {
    mainKey,
    supKey: 'total_sum'
  }
  const dragonTigerKey = {
    mainKey,
    supKey: 'dragon_tiger'
  }

  const keyObj = {
    'ALL:SUM:TAIL:OVER': { ...totalSumKey, groupKey: 'ALL:SUM:TAIL:OVER' },
    'ALL:SUM:TAIL:UNDER': { ...totalSumKey, groupKey: 'ALL:SUM:TAIL:UNDER' },
    '1:5:DRAGON': { ...dragonTigerKey, groupKey: '1:5:DRAGON' },
    '1:5:TIGER': { ...dragonTigerKey, groupKey: '1:5:TIGER' }
  }

  for (const oddsKey of oddsKeyArray) {
    keyObj[`ALL:SUM:${oddsKey}`] = { ...totalSumKey, groupKey: `ALL:SUM:${oddsKey}` }
    for (let i = 1; i <= 5; i++) {
      locateKeys.forEach((supKey, index) => {
        const numIndex = index + 1
        const groupKey = `${numIndex}:${oddsKey}`
        keyObj[groupKey] = {
          mainKey,
          supKey,
          groupKey
        }
      })
    }
  }

  return keyObj
}

const initConsecutiveNum = () => {
  const consecutiveArray = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight']
  const mainKey = 'consecutive_num'
  const keyObj = consecutiveArray.reduce((root, item, index) => {
    const keyIndex = index + 1
    root[`CHOOSE:${keyIndex}:MATCH:${keyIndex > 5 ? 5 : keyIndex}`] = {
      mainKey,
      supKey: `set_${item}_get_${keyIndex > 5 ? 'five' : item}`
    }
    return root
  }, {})
  keyObj['TOP:2:MATCH:2'] = {
    mainKey,
    supKey: 'top_two_group'
  }
  keyObj['TOP:3:MATCH:3'] = {
    mainKey,
    supKey: 'top_three_group'
  }

  return keyObj
}

const initDirect = () => {
  const mainKey = 'direct'
  return {
    'TOP:2:MATCH:ORDER:2': {
      mainKey,
      supKey: 'top_two_direct'
    },
    'TOP:3:MATCH:ORDER:3': {
      mainKey,
      supKey: 'top_three_direct'
    }
  }
}

export default {
  ...initDesignated(),
  ...initTwoSide(),
  ...initConsecutiveNum(),
  ...initDirect()
}
